import { render, staticRenderFns } from "./mobile-level-select.vue?vue&type=template&id=98749864&scoped=true&"
import script from "./mobile-level-select.vue?vue&type=script&lang=ts&"
export * from "./mobile-level-select.vue?vue&type=script&lang=ts&"
import style0 from "./mobile-level-select.vue?vue&type=style&index=0&id=98749864&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98749864",
  null
  
)

export default component.exports